import { render, staticRenderFns } from "./LiuJi.vue?vue&type=template&id=a9213a72&scoped=true"
import script from "./LiuJi.vue?vue&type=script&lang=js"
export * from "./LiuJi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9213a72",
  null
  
)

export default component.exports